<template>
    <div v-if="show" class="modal-wrapper">
        <form class="modal wide" @submit.prevent="nextStep()">
            <h3>Add People</h3>
            <div class="modal-content">
                <div v-if="step === 0" class="field">
                    <label>Enter your contacts in CSV format with 1 contact per line:</label>
                    <textarea v-model="raw" class="monospace" placeholder="Example Name, you@example.com, 199998887777"></textarea>
                </div>

                <div v-if="step === 1" class="field">
                    <div class="field">
                        <label>Identify the fields. It is suggested to use "First Name" and "Last Name" instead of "Name". If you are missing a field, you can add it on your <a href="javascript:;" @click="show = false; app.$router.push('/settings')">Settings</a> page.</label>
                    </div>

                    <table class="table">
                        <thead>
                            <tr>
                                <th v-for="(header, index) in rawPreview[0]" :key="header">
                                    <select v-model="headers[index]">
                                        <option v-for="field in fields" :key="'field-' + field.name" :value="field.name">
                                            {{field.name}}
                                        </option>
                                    </select>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="person in rawPreview" :key="person.toString()">
                                <td v-for="attr in person" :key="person.id + Math.random() + attr">
                                    <a>{{attr}}</a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div v-if="step === 2" class="field">
                    <p>Upload in progress... don't close this window.</p>
                    <p>{{currentImport}} / {{totalImport}} People</p>
                </div>

                <div v-if="step === 3" class="field">
                    Import Complete!
                </div>
            </div>
            <div class="modal-actions">
                <a v-if="step === 0" @click="show = false" href="javascript:;" class="cancel">Cancel</a>
                <a v-if="step < 3 && step !== 0" @click="lastStep()" href="javascript:;" class="cancel">&laquo; &nbsp; Back</a>
                <button type="submit" v-if="step !== 2">
                    <span v-if="step === 0">Next &nbsp; &raquo;</span>
                    <span v-if="step === 1">Add People</span>
                    <span v-if="step === 3">Done</span>
                </button>
            </div>
        </form>
    </div>
</template>

<script>
import async from 'no-async';

export default {
    props: ['app'],
    data() {
        return {
            raw: '',
            step: 0,
            headers: [],
            show: false,
            totalImport: 0,
            currentImport: 0
        };
    },
    computed: {
        rawPreview() {
            var _ = this;
            return _.parseRaw(true);
        },

        fields() {
            var _ = this,
                cols = _.app.columns.map(function(col) {
                    return col;
                });

            return [{ name: 'Ignore' }].concat(cols);
        }
    },
    methods: {
        nextStep() {
            var _ = this;

            _.step++;

            if (_.step === 1) {
                for (var i = _.rawPreview[0].length - 1; i >= 0; i--) {
                    _.headers.push('Ignore');
                }
            } else if (_.step === 2) {
                _.addPeople();
            } else if (_.step === 3) {
                _.step = 0;
                _.show = false;
                _.raw = '';
                _.headers = [];
            }
        },

        lastStep() {
            var _ = this;

            _.step--;
        },

        parseRaw(isPreview) {
            var _ = this,
                lines = _.raw.split(/\n/),
                items = [],
                limit = isPreview ? Math.min(5, lines.length) : lines.length,
                attrs, i;

            for (i = 0; i < limit; i++) {
                if (!lines[i]) {
                    continue;
                }

                attrs = (lines[i] || '').split(',').map(function(str) {
                    return (str || '').trim();
                });

                if (attrs.toString() === 'Ignore') {
                    continue;
                }

                items.push(attrs);
            }

            return items;
        },

        parseWithHeaders() {
            var _ = this,
                raw = _.parseRaw(),
                people = [],
                obj, r, h;

            for (r = 0; r < raw.length; r++) {
                obj = {};

                for (h = 0; h < _.headers.length; h++) {
                    if (_.headers[h]) {
                        obj[_.headers[h]] = raw[r][h];
                    }
                }

                people.push(obj);
            }

            return people;
        },

        addPeople() {
            var _ = this,
                people = _.parseWithHeaders(),
                chunkSize = 50,
                maxChunks = Math.ceil(people.length / chunkSize),
                chunks = [];

            _.totalImport = people.length;

            for (var i = 0; i < maxChunks; i++) {
                chunks.push(i * chunkSize);
            }

            async.eachSeries(chunks, function(startIndex, next) {
                _.currentImport = startIndex + 1;

                _.app.requester.request({
                    controller: 'people',
                    action: 'save',
                    people: people.slice(startIndex, startIndex + chunkSize)
                }, function() {
                    next();
                });
            }, function() {
                _.nextStep();
            });
        }
    }
};
</script>
